module.exports = __webpack_public_path__ + "static/media/(V)_MG_5804_-_Cia_Termal_Beachewear_-_Moda_Feminina_-_Acessorios.97457682.jpg";